module.exports = __webpack_public_path__ + "static/Vicentiu-Bacioiu.5bb759ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Vicentiu-Bacioiu.jpg
// module id = 121
// module chunks = 29270570622601 197429686467972